import React from 'react';
import CarrierSelect from '../CarrierSelect/CarrierSelect';
import CountryGroupSelect from '../CountryGroupSelect/CountryGroupSelect';
import CountryFilterSelect from '../CountryFilterSelect/CountryFilterSelect';

export const REFERENCE_FILTER_TYPES = ['carrier', 'country_group', 'country'];

export const isReferenceFilterType = (type?: string): boolean => !!type && REFERENCE_FILTER_TYPES.includes(type);

type ReferenceFilterSelectProps = {
  type: string;
  value?: string;
  onChange: (id: string) => void;
  disabled?: boolean;
  className?: string;
};

const ReferenceFilterSelect: React.FC<ReferenceFilterSelectProps> = ({
  type,
  value,
  onChange,
  disabled,
  className,
}) => {
  const numericDefault = Number(value) || undefined;
  const handle = (id?: number) => onChange(id != null ? String(id) : '');

  if (type === 'carrier') {
    return (
      <CarrierSelect className={className} disabled={disabled} defaultCarrier={numericDefault} onChange={handle} />
    );
  }
  if (type === 'country_group') {
    return (
      <CountryGroupSelect className={className} disabled={disabled} defaultGroup={numericDefault} onChange={handle} />
    );
  }
  if (type === 'country') {
    return (
      <CountryFilterSelect
        className={className}
        disabled={disabled}
        defaultCountry={numericDefault}
        onChange={handle}
      />
    );
  }
  return null;
};

export default ReferenceFilterSelect;
